export enum Dashboard {

    ArrivalLogs = 'ArrivalLogs',
    BatteryLevel = 'BatteryLevel',
    CardSwap = 'CardSwap',
    IotDevice = 'IotDevice',
    IotGateway = 'IotGateway',
    Spoke = 'Spoke',
    VillageWiFi = 'VillageWiFi'

};